import { Players } from './PlayersEntries';

const fallback = Players()[0];

export const getActivePlayer = (
  allowDirectVideoLinks: boolean,
  src?: string,
) => {
  for (const player of Players(allowDirectVideoLinks)) {
    if (src && player.canPlay(src)) {
      return player;
    }
  }

  if (fallback) {
    return fallback;
  }

  return null;
};
